import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import Analytics from "../AnalyticsService/AnalyticsService";

export const AnalyticsPageTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    Analytics.page(location.pathname);
  }, [location]);

  return null;
};
